import styled from 'styled-components';
import MainTemplate from '../pages/MainTemplate';
import { ADMIN_MENU } from '../common/constants';
import { useQueryClient } from 'react-query';
import { useEffect } from 'react';
import { useGetNaviInfo } from '../interfaces/common';
import { useGetAuthInfo } from '../interfaces/auth';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardTemplate from '../pages/DashboardTemplate';



const MainWrap = styled.div`
    font-family: Pretendard;
    font-weight: 400;
    @media all and ${({ theme }) => theme.windowSize.base} {
        font-size: ${({ theme }) => theme.fontSize.base};
    }
    @media all and ${({ theme }) => theme.windowSize.sm} {
        font-size: ${({ theme }) => theme.fontSize.base};
    }
    @media all and ${({ theme }) => theme.windowSize.lg} {
        font-size: ${({ theme }) => theme.fontSize.lg};
    }
    transition: all ease-in 0.3s;
`;

const MainContainer = ({target, menuKey}) => {

    const queryClient = useQueryClient();
    const param = useParams();

    const navigate = useNavigate();
    const {data: checkData} = useGetNaviInfo(menuKey);
    const {data: authInfo, isLoading: authLoading} = useGetAuthInfo();

    useEffect(()=>{
        if((!authInfo) && (!authLoading)){
            navigate('/login');
        }
    },[authInfo, authLoading])

    useEffect(()=>{
        const temp = ADMIN_MENU[menuKey];
        if(temp || checkData.length === 0){
            const fMenu = temp.TYPE === 'SUB' && ADMIN_MENU[temp.P_MENU];
            if(fMenu){
                switch(menuKey){
                    case 'PROJECT_DETAIL' :
                        const projedtDetailInfo = [{url:fMenu.URL,text:fMenu.TEXT} , {url:fMenu.URL+'/'+param.pno,text:param.pno}];
                        queryClient.setQueryData(['NAVI_INFO'],projedtDetailInfo);
                        break;
                    default :
                        const pathInfo = fMenu.TYPE === 'SUB' ? [{url:ADMIN_MENU[fMenu.P_MENU].URL,text:ADMIN_MENU[fMenu.P_MENU].TEXT} , {url:fMenu.URL,text:fMenu.TEXT}, {url:temp.URL,text:temp.TEXT}] : [{url:fMenu.URL,text:fMenu.TEXT}, {url:temp.URL,text:temp.TEXT}];
                        queryClient.setQueryData(['NAVI_INFO'],pathInfo);
                        break;
                }
            }else{
                const pathInfo = [{url:temp.URL,text:temp.TEXT}];
                queryClient.setQueryData(['NAVI_INFO'],pathInfo);
            }
        }
    },[menuKey, checkData, param])

    return (
        <MainWrap>
            {(authInfo && (authInfo.user_id || authInfo.uid) )&& 
            menuKey !== 'DASHBOARD' ? <MainTemplate target={target}/> : <DashboardTemplate target={target} />}
        </MainWrap>
    )
}

export default MainContainer;